import React, { useEffect, useRef } from "react"
import { graphql, notGatsby } from "gatsby"
import Box from "../atoms/Box"

const CustomSection = ({ versions = [], isActive, scopeClass, section }) => {
  const containerRef = useRef(null)
  const scriptRef = useRef(null)
  const currentVersion = versions.find(v => v.isCurrent) || versions[0] || {}
  const html = currentVersion.html || ""
  const css = currentVersion.css || ""
  const js = currentVersion.js || ""

  useEffect(() => {
    if (scriptRef.current) {
      scriptRef.current.remove()
      scriptRef.current = null
    }
    if (js && containerRef.current) {
      try {
        const script = document.createElement("script")
        script.textContent = js
        containerRef.current.appendChild(script)
        scriptRef.current = script
      } catch (e) {
        console.error("CustomSection: invalid JS, skipping script injection", e)
      }
    }
    return () => {
      if (scriptRef.current) {
        scriptRef.current.remove()
        scriptRef.current = null
      }
    }
  }, [js])

  if (!versions.length) return null

  const { mt, mb, pt, pb, zIndex, minHeight, overflow } = section || {}

  const isTransNavHero = section?.isFirstSection && section?.isTransparentNav && !section?.isNavHidden
  const resolvedPt = isTransNavHero ? undefined : pt
  const navHeight = section?.navHeight || 80
  const transNavStyle =
    isTransNavHero && !notGatsby ? { marginTop: `-${navHeight}px` } : undefined // Morphic site preview positioning is handled by ResizedSiteComponent, so we only apply this in Gatsby.

  return (
    <Box
      ref={containerRef}
      position="relative"
      style={transNavStyle}
      mt={isTransNavHero ? undefined : mt}
      mb={mb}
      pt={resolvedPt}
      pb={pb}
      zIndex={zIndex}
      minHeight={minHeight}
      overflow={overflow}
    >
      <style dangerouslySetInnerHTML={{ __html: css }} />
      {/* In the Morphic site editor, disable pointer events for links and buttons */}
      {notGatsby && (
        <style>{`.${scopeClass} a, .${scopeClass} button { pointer-events: none !important; }`}</style>
      )}
      <div
        className={scopeClass}
        dangerouslySetInnerHTML={{ __html: html }}
        suppressHydrationWarning
      />
      {/* In the Morphic site editor, cover inactive sections with a transparent overlay
          so clicks select the section in the editor instead of triggering its own JS/links. */}
      {notGatsby && !isActive && (
        <div style={{ position: "absolute", inset: 0, zIndex: 1 }} />
      )}
    </Box>
  )
}

export default CustomSection

export const query = graphql`
  fragment CustomSection on STRAPI__COMPONENT_SECTIONS_CUSTOM_SECTION {
    strapi_id
    scopeClass
    CUSTOMSECTIONSection: section {
      ...Section
    }
    versions {
      isCurrent
      versionLabel
      html
      css
      js
      createdAt
      sectionLabel
      strategyString
    }
  }
`
